import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { TimeSheetCategories } from "../../components/TimeSheetCategories";

export const TimeSheetCategoriesPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Categories"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Categories", navigateTo: "#" }
      ]}
      mainContents={<TimeSheetCategories />}
    />
  );
};
